/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliRegisterTeacherDto } from '../../models/amoxcalli-register-teacher-dto';
import { AmoxcalliTeacherDtoApiResponse } from '../../models/amoxcalli-teacher-dto-api-response';

export interface ApiAuthRegisterTeacherPost$Plain$Params {
      body?: AmoxcalliRegisterTeacherDto
}

export function apiAuthRegisterTeacherPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAuthRegisterTeacherPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliTeacherDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAuthRegisterTeacherPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliTeacherDtoApiResponse>;
    })
  );
}

apiAuthRegisterTeacherPost$Plain.PATH = '/api/auth/register/teacher';
